export default __webpack_public_path__ + "static/media/kalahastiPlaceOne.c8ef98bc.jpg";